// extracted by mini-css-extract-plugin
export default {"switch":"Togglestyle_switch__srJ1D","slider":"Togglestyle_slider__9HH33"};